import './App.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/template/Layout"
import Bagni from "./components/page/Bagni Torino"
import IndexPage from './components/page'
import PrivacyPolicy from './components/page/PrivacyPolicy';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<IndexPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path='bagni' element={<Bagni />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
